import { render, staticRenderFns } from "./TariffRateForm.vue?vue&type=template&id=4565e2d8&"
import script from "./TariffRateForm.vue?vue&type=script&lang=js&"
export * from "./TariffRateForm.vue?vue&type=script&lang=js&"
import style0 from "./TariffRateForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TariffRateForm.vue"
export default component.exports